import { post } from './http'

//获取今日各分院考勤情况列表
export function getDayCollegeSignInfo(date) {
    return post('/tyapi/pc/signClassCockpit/getDayCollegeSignInfo', {
        "date":date
    })
}

//获取本学期各分院考勤情况列表
export function getTermCollegeSignInfo(termId) {
    return post('/tyapi/pc/signClassCockpit/getTermCollegeSignInfo', {
        "termId":termId
    })
}
//获取本学期考勤情况列表
export function getTermSignInfo() {
    return post('/tyapi/pc/signClassCockpit/getTermSignInfo', {})
}

//获取本周考勤情况列表
export function getWeekSignInfo() {
    return post('/tyapi/pc/signClassCockpit/getWeekSignInfo', {})
}

//获取本学期到课率
export function getTermAttendanceRate(termId) {
    return post('/tyapi/pc/signClassCockpit/getTermAttendanceRate', {
        "termId":termId
    })
}

//获取本学期各类项目考勤情况
export function getTermItemSignInfo(termId) {
    return post('/tyapi/pc/signClassCockpit/getTermItemSignInfo', {
        "termId":termId
    })
}

//获取本学期重点关注学生-缺课情况
export function getFocusOnStudents_KK() {
    return post('/tyapi/pc/signClassCockpit/getFocusOnStudents_KK', {})
}

//获取学期列表
export function getTermList() {
    return post('/tyapi/pc/signClassCockpit/getTermList', {})
}